import React from "react";
import { RSI_OVERBOUGHT, RSI_OVERSOLD, VOLUME_SURGE_THRESHOLD } from "@/lib/constants";

function toneColor(tone) {
  if (tone === "pos") return "text-[#00e676]";
  if (tone === "neg") return "text-[#ff3b30]";
  if (tone === "warn") return "text-[#ffcc00]";
  return "text-white";
}

function Stat({ label, value, tone }) {
  return (
    <div className="bg-[#0f0f0f] p-4">
      <div className="micro-label">{label}</div>
      <div className={`font-mono-data text-2xl mt-1 ${toneColor(tone)}`}>{value}</div>
    </div>
  );
}

function rsiTone(rsi) {
  if (rsi >= RSI_OVERBOUGHT) return "neg";
  if (rsi <= RSI_OVERSOLD) return "pos";
  return "";
}

function signedTone(v) {
  return v >= 0 ? "pos" : "neg";
}

function signed(v, decimals = 2, suffix = "") {
  const sign = v >= 0 ? "+" : "";
  return `${sign}${v.toFixed(decimals)}${suffix}`;
}

export default function StockStats({ m }) {
  const volTone = m.volume_surge >= VOLUME_SURGE_THRESHOLD ? "warn" : "";
  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-px bg-[#222] border border-[#222] mb-4">
      <Stat label="RSI (14)" value={m.rsi.toFixed(1)} tone={rsiTone(m.rsi)} />
      <Stat label="MACD HIST" value={signed(m.macd_hist, 3)} tone={signedTone(m.macd_hist)} />
      <Stat label="5D %" value={signed(m.change_5d, 2, "%")} tone={signedTone(m.change_5d)} />
      <Stat label="20D %" value={signed(m.change_20d, 2, "%")} tone={signedTone(m.change_20d)} />
      <Stat label="VOL × 20D" value={`${m.volume_surge.toFixed(2)}×`} tone={volTone} />
      <Stat label="MOM SCORE" value={m.momentum_score.toFixed(0)} tone={signedTone(m.momentum_score)} />
    </div>
  );
}
